<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="germplasm-list.import.review.header"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div class="modal-body">
	<div>
		<div class="row mb-sm-3">
			<div class="col">
				<span jhiTranslate="germplasm-list.import.review.description"></span>
			</div>
		</div>
	<form>
		<div class="mb-3 row">
			<div class="col">
				<jhi-column-filter [request]="request" [filters]="filters" [eventName]="COLUMN_FILTER_EVENT_NAME"
							   [isCollapsed]="true" [sectionLabel]="sectionLabel" [filterDropdownLabel]="filterDropdownLabel"
								class="flex-sm-grow-1"></jhi-column-filter>
			</div>
			<div class="col-sm-auto">
				<label for="showMatchesDropdown" class="col-sm-auto col-form-label">
					<span jhiTranslate="germplasm-list.import.review.show.matches"></span>:
				</label>
				<select class="form-select" id="showMatchesDropdown" name="showMatchesDropdown"
						(change)="onShowMatchesOptionChange()"
						[(ngModel)]="showMatchesOption" #showMatchesDropdown="ngModel">
					<option [value]="SHOW_MATCHES_OPTIONS.ALL">{{ 'germplasm-list.import.review.show.matches.all' | translate}}</option>
					<option [value]="SHOW_MATCHES_OPTIONS.WITH_A_SINGLE_MATCH">{{ 'germplasm-list.import.review.show.matches.single.match' | translate}}</option>
					<option [value]="SHOW_MATCHES_OPTIONS.WITH_MULTIPLE_MATCHES">{{ 'germplasm-list.import.review.show.matches.multipe.match' | translate}}</option>
					<option [value]="SHOW_MATCHES_OPTIONS.WITHOUT_MATCHES">{{ 'germplasm-list.import.review.show.matches.without.matches' | translate}}</option>
				</select>
			</div>
		</div>
		<div class="row" *ngIf="!isLoading else throbber">
			<div class="col">
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-curved">
						<thead>
                        <tr>
						<th>#</th>
						<th>{{ ('germplasm.import.list.review.headers.' + HEADERS.GID) | translate}}</th>
						<th>{{ ('germplasm.import.list.review.headers.' + HEADERS.GUID) | translate}}</th>
						<th>{{ ('germplasm.import.list.review.headers.' + HEADERS.DESIGNATION) | translate}}</th>
						<th *ngFor="let variable of context.newVariables">
							{{variable.alias ? variable.alias : variable.name}}
						</th>
						<th>{{ ('germplasm.import.list.review.headers.' + HEADERS.GID_MATCHES) | translate}}</th>
                        </tr>
						</thead>
						<tbody *ngIf="rows && rows.length else nodata">
						<tr *ngFor="let row of rows | orderBy: HEADERS.ROW_NUMBER | slice: (page-1) * pageSize : page * pageSize">
							<td><span>{{row[HEADERS.ROW_NUMBER]}}</span></td>
							<td *ngIf="matchesByGid[toUpper(row[HEADERS.GID])]">
								{{row[HEADERS.GID]}} <span class="fa fa-check-circle text-success"></span>
							</td>
							<td *ngIf="!this.matchesByGid[toUpper(row[HEADERS.GID])]">
								<span>{{row[HEADERS.GID]}}</span>
							</td>
							<td *ngIf="this.matchesByGUID[toUpper(row[HEADERS.GUID])]">
								{{row[HEADERS.GUID]}} <span class="fa fa-check-circle text-success"></span>
							</td>
							<td *ngIf="!this.matchesByGUID[toUpper(row[HEADERS.GUID])]">
								<span>{{row[HEADERS.GUID]}}</span>

							<td *ngIf="this.matchesByName[toUpper(row[HEADERS.DESIGNATION])]">
								{{row[HEADERS.DESIGNATION]}} <span class="fa fa-check-circle text-success"></span>
							</td>
							<td *ngIf="!this.matchesByName[toUpper(row[HEADERS.DESIGNATION])]">
								<span>{{row[HEADERS.DESIGNATION]}}</span>
							</td>
							<td *ngFor="let variable of context.newVariables">
								{{row[toUpper(variable.alias)] ? row[toUpper(variable.alias)] : row[toUpper(variable.name)]}}
							</td>
							<td>
								<span *ngFor="let germplasm of row[HEADERS.GID_MATCHES]; index as i">
									<a class="link" [href]="this.germplasmDetailsUrlService.getUrl(germplasm.gid)" target="_blank">
										{{germplasm.gid}}{{row[HEADERS.GID_MATCHES].length === (i+1)?" ":","}}</a>
								</span>
							</td>
						</tr>
						</tbody>
					</table>
					<ng-template #nodata>
						<tbody>
						<tr>
							<td [attr.colspan]="(this.context.newVariables.length)+6"><span jhiTranslate="no.data"></span></td>
						</tr>
						</tbody>
					</ng-template>
				</div>
				<div><a *ngIf="rows.length > 0" href (click)="exportTableToExcel($event)" jhiTranslate="germplasm-list.import.review.export.table"> Download this table</a></div>
				<div class="row">
					<div class="col">
						<div class="pagination-container">
							<div class="pagination-box pagination-box-left">
								<div>
									<jhi-item-count [page]="page" [total]="rows.length" [itemsPerPage]="pageSize"></jhi-item-count>
								</div>
							</div>
							<div class="pagination-box">
								<ngb-pagination [collectionSize]="rows.length" [(page)]="page" [pageSize]="pageSize" [disabled]="isLoading"
												[maxSize]="5" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
							</div>
							<div class="pagination-box pagination-box-right">
							</div>
						</div>
					</div>
				</div>
				<div class="row" *ngIf="dataMultipleMatches.length > 0">
					<div class="col">
						<div class="form-check form-check-inline">
							<input type="checkbox" class="form-check-input" name="skipMultiMatchesCheckbox" id="skipMultiMatchesCheckbox"
								   [(ngModel)]="skipMultipleMatches">
							<label class="form-check-label" for="skipMultiMatchesCheckbox" jhiTranslate="germplasm-list.import.review.skip.multi.matches">
							</label>
						</div>
					</div>
				</div>
				<div class="row" *ngIf="dataWithOutMatches.length > 0">
				<div class="col">
						<div class="form-check form-check-inline">
							<input type="checkbox" class="form-check-input" name="skipDataWithoutMatchesCheckbox" id="skipDataWithoutMatchesCheckbox"
								   [(ngModel)]="skipDataWithoutMatches">
							<label class="form-check-label" for="skipDataWithoutMatchesCheckbox" jhiTranslate="germplasm-list.import.review.skip.data.with.out.matches">
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="back()">
		<span jhiTranslate="back"></span>
	</button>
	<button (click)="save()" class="btn btn-primary" [disabled]="isLoading || isSaving || rows && rows.length === 0"
			data-test="importSubmit">
		<span *ngIf="isSaving" class="throbber throbber-btn"></span>
		<span class="fa fa-save"></span>&nbsp;<span jhiTranslate="next"></span>
	</button>
</div>
<ng-template #throbber>
	<span class="throbber"></span>
</ng-template>

